export default __webpack_public_path__ + "static/media/963hz-spiritual-oneness.e119d614.mp3";